import styled from 'styled-components'
import H3 from '../../../components/general/H3'
import { PrintList } from '../../../components/card/PrintList'
import { desktop, mobile } from '../../../styles/media'
import { StyledActionButton } from '../../../components/button/ActionButton'

const ToolbarFlyout = styled.div`
	background: ${props => props.legal ? props.theme.greenLight : props.theme.redLight};
	border-radius: 2px;
	padding: 1rem;

	${H3}:first-child {
		padding-top: 0;
	}

	${PrintList}, p:last-child {
		margin-bottom: 0;
	}

	${StyledActionButton} {
		margin-bottom: 1rem;
		width: fit-content;
	}

	${PrintList} a {
		border-bottom-color: #f9d6d7;
		padding: 0.5rem;
		margin: 0 -0.5rem;

		${desktop`
			&:hover {
				background: ${props => props.theme.id === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.35)'} !important;
			}
		`}

		${mobile`
			&:active {
				background: ${props => props.theme.id === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.35)'} !important;
			}
		`}
	}

	${props => props.centered && `
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;

		svg {
			height: 25px;
			width: 25px;
			margin-bottom: 1rem;
		}
	`}

	${props => props.info && `
		background ${props.theme.backgroundLight};

		${PrintList} a {
			border-bottom-color: ${props.theme.id === 'dark' ? props.theme.backgroundVeryLight : props.theme.backgroundConcrete};
		}
	`}

	${mobile`
		margin-bottom: 1rem;
	`}
`

export default ToolbarFlyout
